import { useMutation } from 'react-query';

import { BookAppointmentResponse,UploadImageResponse ,CreditCarddetails} from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
  data: {
    firstName: string;
    lastName: string;
    phone: string;
    altEmails: string[],
    address: string;
    city: string;
    state: string;
    zip: string;
    apt?: string;
    lat?: number;
    lng?: number;
    imageUrl? : string
    country: string
    optOutSms: boolean;
    optOutIvr: boolean;
    name?: string;
    id?:string;
  };
};

export type requestDTOCard = {
  data: {
  deleteCardId:number
  };
};




export type requestDTOUploadImage = {
  file : FormData
};

export const updateParentProfile = ({ data }: requestDTO): Promise<BookAppointmentResponse> => {
  return axios.post(`parent/profile`, data);
};

export const updateCreditCard = ({ data }: requestDTOCard): Promise<CreditCarddetails> => {
  return axios.post(`parent/delete-card`, data);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof updateParentProfile>;
};

type UseUpdateCreditCardOptions = {
  deleteCardId?: MutationConfig<typeof updateCreditCard>;
};

export const addPetPicture = ({ file }: requestDTOUploadImage): Promise<UploadImageResponse> => {
  return axios.post(`parent/upload-image`, file);
};


type UseUpdateBusinessOptions1 = {
  config?: MutationConfig<typeof addPetPicture>;
};


export const useUpdateParentProfile = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Parent profile set successfully',
      });
    },
    ...config,
    mutationFn: updateParentProfile,
  });
};
export const useUpdateCreditCard = ({ deleteCardId }: UseUpdateCreditCardOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Credit Card deleted successfully',
      });
    },
    ...deleteCardId,
    mutationFn: updateCreditCard,
  });
};


export const useUploadPicture = ({ config }: UseUpdateBusinessOptions1 = {}) => {
  return useMutation({
    onSuccess: () => {
      // showNotification({
      //   type: 'success',
      //   title: 'Profile picture uploaded successfully',
      // });
    },
    ...config,
    mutationFn: addPetPicture,
  });
};




type UseBusinessOptions = {
  businessId?: number;
  page: number;
  perPage: number;
};

export type OrdersListResponse = {
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
  list: any;
};

export const getOrderList = (
  { businessId, page, perPage }: UseBusinessOptions = {
    page: 1,
    perPage: 50,
  }
): Promise<OrdersListResponse> => {
  return axios.get( `/parent/orders`,
    {
      params: {  page, perPage,businessId },
    }
  );
};

type UseUpdateBusineOptions = {
  config?: MutationConfig<typeof getOrderList>;
};

export const useGetOrders = ({ config }: UseUpdateBusineOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getOrderList,
  });
};

